var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTimecardNav = function SvgTimecardNav(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0489 3.30054V2.19995H15.9495V3.30054H11.5495V2.19995H10.4501V3.30054H6.0501V2.19995H4.95069V3.30054C4.22155 3.30116 3.52242 3.59092 3.00662 4.10628C2.49082 4.62164 2.20046 5.32052 2.19922 6.04966V17.0497C2.20015 17.7788 2.49021 18.4778 3.00579 18.9934C3.52137 19.509 4.22038 19.799 4.94951 19.7999H17.0489C17.7781 19.799 18.4771 19.509 18.9927 18.9934C19.5082 18.4778 19.7983 17.7788 19.7992 17.0497V6.04966C19.798 5.32072 19.5078 4.62202 18.9922 4.10669C18.4767 3.59137 17.7779 3.30147 17.0489 3.30054ZM18.6986 17.0508C18.698 17.4882 18.524 17.9074 18.2148 18.2167C17.9055 18.5259 17.4863 18.6999 17.0489 18.7005H4.94951C4.51218 18.6999 4.09292 18.5259 3.78368 18.2167C3.47443 17.9074 3.30043 17.4882 3.29981 17.0508V6.04966C3.30043 5.61232 3.47443 5.19307 3.78368 4.88382C4.09292 4.57458 4.51218 4.40057 4.94951 4.39995V5.50054H6.0501V4.40112H10.4501V5.50171H11.5507V4.4023H15.9507V5.50288H17.0513V4.40347C17.4886 4.40409 17.9079 4.5781 18.2171 4.88735C18.5264 5.19659 18.7004 5.61584 18.701 6.05318L18.6986 17.0508Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05142 9.07451C6.50697 9.07451 6.87627 8.70521 6.87627 8.24966C6.87627 7.7941 6.50697 7.4248 6.05142 7.4248C5.59586 7.4248 5.22656 7.7941 5.22656 8.24966C5.22656 8.70521 5.59586 9.07451 6.05142 9.07451Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34829 9.07451C9.80385 9.07451 10.1731 8.70521 10.1731 8.24966C10.1731 7.7941 9.80385 7.4248 9.34829 7.4248C8.89274 7.4248 8.52344 7.7941 8.52344 8.24966C8.52344 8.70521 8.89274 9.07451 9.34829 9.07451Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6491 9.07451C13.1046 9.07451 13.4739 8.70521 13.4739 8.24966C13.4739 7.7941 13.1046 7.4248 12.6491 7.4248C12.1935 7.4248 11.8242 7.7941 11.8242 8.24966C11.8242 8.70521 12.1935 9.07451 12.6491 9.07451Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9499 9.07451C16.4054 9.07451 16.7747 8.70521 16.7747 8.24966C16.7747 7.7941 16.4054 7.4248 15.9499 7.4248C15.4943 7.4248 15.125 7.7941 15.125 8.24966C15.125 8.70521 15.4943 9.07451 15.9499 9.07451Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05142 12.375C6.50697 12.375 6.87627 12.0057 6.87627 11.5502C6.87627 11.0946 6.50697 10.7253 6.05142 10.7253C5.59586 10.7253 5.22656 11.0946 5.22656 11.5502C5.22656 12.0057 5.59586 12.375 6.05142 12.375Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34829 12.375C9.80385 12.375 10.1731 12.0057 10.1731 11.5502C10.1731 11.0946 9.80385 10.7253 9.34829 10.7253C8.89274 10.7253 8.52344 11.0946 8.52344 11.5502C8.52344 12.0057 8.89274 12.375 9.34829 12.375Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6491 12.375C13.1046 12.375 13.4739 12.0057 13.4739 11.5502C13.4739 11.0946 13.1046 10.7253 12.6491 10.7253C12.1935 10.7253 11.8242 11.0946 11.8242 11.5502C11.8242 12.0057 12.1935 12.375 12.6491 12.375Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9499 12.375C16.4054 12.375 16.7747 12.0057 16.7747 11.5502C16.7747 11.0946 16.4054 10.7253 15.9499 10.7253C15.4943 10.7253 15.125 11.0946 15.125 11.5502C15.125 12.0057 15.4943 12.375 15.9499 12.375Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05142 15.6746C6.50697 15.6746 6.87627 15.3053 6.87627 14.8498C6.87627 14.3942 6.50697 14.0249 6.05142 14.0249C5.59586 14.0249 5.22656 14.3942 5.22656 14.8498C5.22656 15.3053 5.59586 15.6746 6.05142 15.6746Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34829 15.6746C9.80385 15.6746 10.1731 15.3053 10.1731 14.8498C10.1731 14.3942 9.80385 14.0249 9.34829 14.0249C8.89274 14.0249 8.52344 14.3942 8.52344 14.8498C8.52344 15.3053 8.89274 15.6746 9.34829 15.6746Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6491 15.6746C13.1046 15.6746 13.4739 15.3053 13.4739 14.8498C13.4739 14.3942 13.1046 14.0249 12.6491 14.0249C12.1935 14.0249 11.8242 14.3942 11.8242 14.8498C11.8242 15.3053 12.1935 15.6746 12.6491 15.6746Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimecardNav, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timecard-nav.aeb6526d.svg";
export { ForwardRef as ReactComponent };